<!-- WITH INFO ICON -->
<div *ngIf="showInfo" class="homeTrade buttonPointer">
    <div (click)="showTradeTypeInformationPopup()" class="tradeTypeInformationIconContainer">
        <img class="tradeTypeInformationIconImg" src="assets/img/3978/icons/info.png" />
    </div>
    <div (click)="triggerExternalRedirect()">
        <img [src]=iconSrc />
        <div class="tradeName">{{tradeName.toUpperCase()}}</div>
        <div class="standardButton tradeBookButton buttonPointer">{{ 'Home.BookNowButton' | translate:pageContentParams }}</div>
    </div>
</div>

<!-- WITHOUT INFO ICON -->
<div *ngIf="!showInfo" class="homeTrade buttonPointer"  (click)="triggerExternalRedirect()">
    <img [src]=iconSrc />
    <div class="tradeName">{{tradeName.toUpperCase()}}</div>
    <div class="standardButton tradeBookButton buttonPointer">{{ 'Home.BookNowButton' | translate:pageContentParams }}</div>
</div>